import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-policy-footer',
    imports: [RouterModule],
    templateUrl: './policy-footer.component.html',
    styleUrl: './policy-footer.component.css'
})
export class PolicyFooterComponent {

}
